export function fixedBtn() {

    const showBtn = (elem, btn, hideInTheEnd, onlyAfter) => {
        const offerBtn = document.querySelector(elem);
        const fixedBtn = document.querySelector(btn);

        if (!offerBtn) {
            return false
        }

        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight,
            windowScroll = document.documentElement.scrollTop || document.body.scrollTop,
            elemRect = windowScroll + offerBtn.getBoundingClientRect().top,
            windowCordStart = windowScroll,
            windowCordEnd = windowHeight + windowScroll,
            elemCordStart = windowScroll + offerBtn.getBoundingClientRect().top,
            elemCordEnd = elemRect + offerBtn.clientHeight;


        let condition = elemCordStart <= windowCordEnd && windowCordStart <= elemCordEnd;

        if (onlyAfter) {
            condition = windowCordStart <= elemCordEnd;
        }

        if (condition) {
            fixedBtn.classList.remove('is-active')
        } else {
            fixedBtn.classList.add('is-active')
        }

        if (!hideInTheEnd) {
            return false;
        }

        let domHeight = document.documentElement.offsetHeight - document.documentElement.clientHeight || document.body.offsetHeight - document.body.clientHeight;
        let scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        if (domHeight == scroll - 1) {
            fixedBtn.classList.remove('is-active');
        }
    }

    const initBtns = () => {

        if (document.body.classList.contains('ab-test') && window.innerWidth < 767) {
            showBtn('[data-fixed-point]', '.js-fixedBtn');
            window.addEventListener('scroll', function() {
                showBtn('[data-fixed-point]', '.js-fixedBtn');
            });
        }

        if (window.innerWidth < 999) {
            showBtn('[data-point]', '.js-servicesBtn', true, true);
            window.addEventListener('scroll', function() {
                showBtn('[data-point]', '.js-servicesBtn', true, true);
            });
        }
    }

    initBtns();
    window.addEventListener('resize', initBtns);
    window.addEventListener('orientationchange', initBtns);
}